import { Box, FormControl, MenuItem, Select } from '@mui/material';
import { ButtonForm, CustomTextField } from 'Components/Form/styles';
import { Column, Row } from 'Components/Grid';
import { useNavigate } from 'react-router-dom';
import { validatePhone } from 'utils/phone_validators';
import { useTranslation } from 'react-i18next';

export const Detalhes = ({ handleComplete, register, handleSubmit, errors, phonePrefix, phoneFormat, countryCode, allConfigs = [], setPhoneCountry }) => {
  const { t } = useTranslation(['company']);
  // const theme = useTheme()
  const navigate = useNavigate();
  const onSubmit = () => {
    handleComplete();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-100">
      <Row>
        <Column xs={12} xl={4} className="d-flex">
          <div data-tour="office-name" style={{ width: '100%' }}>
          <CustomTextField
            {...register('name', { required: t('company:offices.form.nameRequired') })}
            label={t('company:offices.form.name')}
            autoFocus
            error={errors?.name ? true : false}
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            helperText={errors?.name ? errors.name.message : null}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
        <Column xs={12} xl={4} className="d-flex">
          <div data-tour="office-address" style={{ width: '100%' }}>
          <CustomTextField
            {...register('address')}
            label={t('company:offices.form.address')}
            // error={errors?.name ? true : false}
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            // helperText={errors?.name ? errors.name.message : null}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
        <Column xs={12} xl={4} className="d-flex">
          <div data-tour="office-phone" style={{ width: '100%', display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
            {allConfigs.length > 0 && (
              <FormControl sx={{ flexShrink: 0, marginBottom: '24px' }}>
                <Select
                  value={countryCode || ''}
                  onChange={(e) => setPhoneCountry(e.target.value)}
                  displayEmpty
                  sx={{ minWidth: '90px' }}
                  renderValue={(val) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      {val && <img src={`https://flagcdn.com/20x15/${val.toLowerCase()}.png`} alt={val} width={20} height={15} />}
                      <span style={{ fontSize: '0.8rem' }}>{phonePrefix}</span>
                    </Box>
                  )}
                >
                  {allConfigs.map((c) => (
                    <MenuItem key={c.countryCode} value={c.countryCode}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <img src={`https://flagcdn.com/20x15/${c.countryCode.toLowerCase()}.png`} alt={c.countryCode} width={20} height={15} />
                        {c.name.pt} ({c.phonePrefix})
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            <CustomTextField
              {...register('phone', {
                validate: (value) => {
                  if (!validatePhone(value, phoneFormat)) {
                    return t('company:offices.form.phoneInvalid', { format: phoneFormat });
                  }
                  return true;
                },
              })}
              label={t('company:offices.form.phone')}
              error={errors?.phone ? true : false}
              helperText={errors?.phone ? errors.phone.message : null}
              sx={{ minHeight: '48px', margin: '0 auto 24px', flex: 1 }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </Column>
      </Row>
      <div data-tour="form-actions">
      <Row justifyContent="end" alignItems="center">
        <Column xs={4} xl={3} className="d-flex" style={{ gap: '8px', justifyContent: 'flex-end' }}>
          <ButtonForm secondary id="cancel" label={t('company:offices.form.cancel')} onClick={() => navigate('/offices')}></ButtonForm>
          <ButtonForm label={t('company:offices.form.save')} type="submit" />
        </Column>
      </Row>
      </div>
    </form>
  );
};
